var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-method"},[_c('a',{staticClass:"payment-btn",class:{
      selected:
        _vm.selectedPaymentMethod &&
        _vm.selectedPaymentMethod.id === _vm.paymentMethod.id,
      recommended: _vm.paymentMethod.group === 'recommended',
    },attrs:{"href":"#!"},on:{"click":function($event){return _vm.setPaymentMethod(_vm.paymentMethod)}}},[_c('h5',{staticClass:"action"},[_vm._v("\n      "+_vm._s(_vm.mainLabel)+"\n    ")]),_c('div',{staticClass:"payment-method-img-container"},[_c('img',{staticClass:"payment-method-img",attrs:{"src":_vm.paymentMethod.image_url,"alt":_vm.paymentMethod.name}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }